import globalPostFields from '@/lib/wp/_partials/globalPostFields';
import featuredImageFields from '@/lib/wp/media/featuredImage';
import seoPostFields from '@/lib/wp/_partials/seoPostFields';
import defaultPageData from '@/lib/wp/_partials/defaultPageData';
import authorFields from '@/lib/wp/_partials/authorFields';
import taxonomyTerms from '@/lib/wp/_partials/taxonomyTerms';
import primaryTag from '@/lib/wp/_partials/primaryTag';
import bylineCustomFields from '@/lib/wp/_partials/byline';
import partnerBrandingFields from "@/lib/wp/_partials/partnerBrandingFields";
import { gql } from '@apollo/client';

const singlePostFragment = gql`
  fragment SinglePostFields on Post {
    ${globalPostFields}
    blocksJSON
    ${featuredImageFields}
    ${seoPostFields}
    ${authorFields}
    ${bylineCustomFields}
    ${partnerBrandingFields}
    excerpt
    focalPointX
    focalPointY
    readingTime
    ${taxonomyTerms}
    ${primaryTag} 
  }
`;

const queryPostById = gql`
  query GET_POST_BY_ID($id: ID!, $idType: PostIdType = SLUG, $imageSize: MediaItemSizeEnum = LARGE) {
    ${defaultPageData}
    post(id: $id, idType: $idType) {
      ...SinglePostFields
    }
  }
  ${singlePostFragment}
`;

export default queryPostById;
